module.exports = __webpack_public_path__ + "img/5terGeburtstag.bfb51177.jpg";